import { render, staticRenderFns } from "./RelationsTester.vue?vue&type=template&id=6e5bf3d9"
import script from "./RelationsTester.vue?vue&type=script&lang=js"
export * from "./RelationsTester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports